import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { Home, Users, UserCheck, Handshake, FileText, DollarSign, CheckSquare, Megaphone, Package, Bell, Settings, LogOut } from 'lucide-react';

const Sidebar = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', icon: Home, label: t('dashboard'), roles: ['admin', 'employee', 'client'] },
    { path: '/clients', icon: Users, label: t('clients'), roles: ['admin', 'employee'] },
    { path: '/deals', icon: Handshake, label: t('deals'), roles: ['admin', 'employee'] },
    { path: '/contracts', icon: FileText, label: t('contracts'), roles: ['admin', 'employee'] },
    { path: '/finances', icon: DollarSign, label: t('finances'), roles: ['admin', 'employee'] },
    { path: '/tasks', icon: CheckSquare, label: t('tasks'), roles: ['admin', 'employee'] },
    { path: '/marketing', icon: Megaphone, label: t('marketing'), roles: ['admin', 'employee'] },
    { path: '/equipment', icon: Package, label: t('equipment'), roles: ['admin', 'employee'] },
    { path: '/users', icon: UserCheck, label: 'Потребители / Служители', roles: ['admin'] }
  ];

  const filteredMenu = menuItems.filter(item => item.roles.includes(user?.role));

  return (
    <div className="sidebar" data-testid="sidebar">
      <div className="sidebar-header">
        <img 
          src="https://customer-assets.emergentagent.com/job_6328ef84-4bcd-4029-8d62-7f91e39a9a93/artifacts/3vjif819_97c6b968ff444f522898e577c3b08e60.png" 
          alt="FleetFlow Logo" 
          className="sidebar-logo"
          data-testid="sidebar-logo"
        />
      </div>

      <nav className="sidebar-nav">
        {filteredMenu.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar-item ${isActive ? 'active' : ''}`}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="user-avatar" data-testid="user-avatar">
            {user?.name?.charAt(0)}
          </div>
          <div className="user-info">
            <div className="user-name">{user?.name}</div>
            <div className="user-role">{user?.role}</div>
          </div>
        </div>
        <button onClick={logout} className="sidebar-logout" data-testid="logout-btn">
          <LogOut size={20} />
          <span>{t('logout')}</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
